import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing hooks
import { useTranslation } from 'react-i18next';
// Importing icons
import AudioNotFoundIcon from '@mui/icons-material/MusicOffRounded';
import VideoNotFoundIcon from '@mui/icons-material/PlayDisabledRounded';
// Importing types
import { PlayerType } from '../../types/player';
// Importing 3rd party components
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ----------------------------------------------------------------------
export const PlayerNotFound = (props) => {
    // Desctructuring props
    const { type } = props;
    // Adding hooks
    const { t } = useTranslation();
    return (_jsxs(Stack, { alignItems: "center", height: type === PlayerType.audio ? '20vh' : '40vh', justifyContent: "center", width: "100%", children: [type === PlayerType.audio ? (_jsx(AudioNotFoundIcon, { fontSize: "xxlarge", sx: { color: 'white', mb: 4 } })) : (_jsx(VideoNotFoundIcon, { fontSize: "xxlarge", sx: { color: 'white', mb: 4 } })), _jsx(Typography, { sx: { color: 'white' }, variant: "h5", children: t('player:content:notFound:title') })] }));
};
